import { t } from "i18next";
import React, { useState } from "react";
 import "./style.css"
export default function Extra({ setExtra }) {
  const [checked, setChecked] = useState([]);
   const checkList = [{name :"Apple Ext",price:10},{name :"Banana Ext",price:50}  , {name :"Coffee Ext",price:20} , {name :"tomato Ext",price:20}];
  const hendalSubmit = (event) => {
    event.preventDefault()
    let dataExtr= []
    checked.forEach((item)=>{
     let index =  checkList.findIndex((indexItem) => indexItem.name ===  item)
     dataExtr.push(checkList[index] )
    })
   
    setExtra(dataExtr)
    setChecked('')
  
  };
  const handleCheck = (event) => {
    var updatedList = [...checked];
    if (event.target.checked) {
      updatedList = [...checked, event.target.value];
    } else {
      updatedList.splice(checked.indexOf(event.target.value), 1);
    }
    setChecked(updatedList);
  }
  return (
    <>
      <div
        className="modal fade"
        id="Extra"
        tabIndex="-1"
        aria-labelledby="WithOutLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
          <form className="fs-5" onSubmit={(event) => hendalSubmit(event)}>
            <div className="text-center">
              <h4 className="modal-title " id="NotesCompLabel">
                {t("extra")}{" "}
              </h4>
            </div>
            <div className="modal-body">
              
                <div className="row">
                  {
                    checkList.map((item, index) => (
                            <div key={index} className="col-12 col-sm-4 my-2 ">
                                  <div className="form-check ">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id={item.name}
                                value={item.name}
                                checked={checked.includes(item.name)}
                                onChange={handleCheck} 
                              />
                              <label className="form-check-label" htmlFor={item.name}>
                               {item.name}:-  {item.price}$:
                              </label>
                            </div>
                           </div>

                    ))
                  }
                 
                 
                </div>
              
              
              
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                {t("Discard")}
              </button>
              <button
                type="submit"
                className="btn py-1 red_btn"
                 
                data-bs-dismiss="modal"
              >
                {t("Confirm")}
              </button>
            </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
